import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

export const Lightbox = ({ src, alt, className = "", children }) => {
 const [open, setOpen] = useState(false);

 useEffect(() => {
  if (!open) return;
  const onKey = (e) => e.key === "Escape" && setOpen(false);
  document.body.style.overflow = "hidden";
  window.addEventListener("keydown", onKey);
  return () => {
   document.body.style.overflow = "";
   window.removeEventListener("keydown", onKey);
  };
 }, [open]);

 return (
  <>
   <button
    type="button"
    onClick={() => setOpen(true)}
    className={`block w-full h-full text-left cursor-zoom-in group ${className}`}
    aria-label={`Open ${alt} in lightbox`}
    data-testid="lightbox-trigger"
   >
    {children}
   </button>
   {open && createPortal(
    <div
     onClick={() => setOpen(false)}
     className="fixed inset-0 z-[200] bg-black/95 backdrop-blur-md flex items-center justify-center p-4 sm:p-10 cursor-zoom-out animate-fade-in"
     role="dialog"
     aria-modal="true, "
     aria-label={alt}
     data-testid="lightbox-overlay"
    >
     <button
      type="button"
      onClick={(e) => { e.stopPropagation(); setOpen(false); }}
      className="absolute top-5 right-5 sm:top-8 sm:right-8 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white inline-flex items-center justify-center transition-colors backdrop-blur ring-1 ring-white/20"
      aria-label="Close lightbox"
      data-testid="lightbox-close"
     >
      <X className="w-5 h-5" />
     </button>
     <img
      src={src}
      alt={alt}
      onClick={(e) => e.stopPropagation()}
      className="max-w-full max-h-full object-contain rounded-lg shadow-[0_40px_120px_-20px_rgba(0,0,0,0.8)]"
     />
     <div className="absolute bottom-5 sm:bottom-8 left-0 right-0 text-center text-white/65 text-[11px] uppercase tracking-[0.28em] font-bold px-6">
      Click anywhere or press ESC to close
     </div>
    </div>,
    document.body
   )}
  </>
 );
};
